module.exports = __webpack_public_path__ + "img/about-right.db1a75f9.png";